import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Globals } from '../../../globals';
import { OrdersServices } from '../../kitchen/services';
import { PrintServices } from '../../services/printServices';
import { PrinterSunmiAutoPage } from '../printer-sunmi-auto/printer-sunmi-auto';





@Component({
  selector: 'printer-sunmi-queue',
  templateUrl: 'printer-sunmi-queue.html',
})
export class PrinterSunmiQueuePage {

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public printServices: PrintServices,
    public ordersServices: OrdersServices,
    public globals: Globals) {
  }

  onBack() {
    this.navCtrl.push(PrinterSunmiAutoPage);
  }

  async print(order) {
    //enviar todas las ordenes
    this.printServices.prepareOrderKitchen('order', order, order, this.globals.restaurant.printer_type, 'sections');

  }

  async ionViewWillEnter() {
    //config nueva
    this.printServices.configSetPrintSunmiAuto();
    //
    await this.ordersServices.getOrdersShowPrinted(this.globals.restaurant_uid);
  }

  async ionViewWillLeave() {
    //config anterior
    this.printServices.configResetPrintSunmiAuto();
    //unsubscribe del service
    this.ordersServices.ordersPrinteSubscribe.unsubscribe();
  }
  back() {
    this.navCtrl.pop();
  }

}



// WEBPACK FOOTER //
// ./src/pages/printer-sunmi/printer-sunmi-queue/printer-sunmi-queue.ts